// Dashboard Module Mutation Types
export const SET_DASHBOARD_DATA = "SET_DASHBOARD_DATA";
export const SET_DASHBOARD_LOADING = "SET_DASHBOARD_LOADING";
export const SET_DASHBOARD_ERROR = "SET_DASHBOARD_ERROR";
export const SET_SELLER_TICKET_COUNT = "SET_SELLER_TICKET_COUNT";
export const SET_N11_TICKET_COUNT = "SET_N11_TICKET_COUNT";
